/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
  {
    id: "Wo5dMEP_BbI",
    title: "Friends",
    description: "Let's see how well you know friends",
    category: "Web Series",
  },
  {
    id: "fe5dMEP_Sui",
    title: "Suits",
    description: "Do you think you know all about Suits? Let's check",
    category: "Web Series",
  },
];
